import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_URL = "/api"; // Base API URL

export const portfolioApi = createApi({
  reducerPath: "portfolioApi", // Unique key for the API slice
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }), // Configures the base query
  tagTypes: ["Portfolio"], // Define tags used for caching and invalidation
  endpoints: (builder) => ({
    // Mutation to save a portfolio link
    savePortfolioLink: builder.mutation({
      query: ({ token, data }) => ({
        url: "/portfolio", // API endpoint for saving portfolio links
        method: "POST", // HTTP method
        headers: {
          Authorization: `Bearer ${token}`, // Bearer token for authentication
        },
        body: data, // Request payload
      }),
      invalidatesTags: ["Portfolio"], // Invalidate cache after mutation
    }),

    // Query to fetch a portfolio link for a specific student
    getPortfolioLink: builder.query({
      query: (studentId) => ({
        url: `/portfolio/${studentId}`,
        method: "GET",
      }),
      providesTags: (result, error, { studentId }) => [
        { type: "Portfolio", id: studentId },
      ],
    }),

    // Query to fetch all portfolio links
    getAllPortfolio: builder.query({
      query: (token) => ({
        url: "/portfolio", // API endpoint for fetching all portfolio links
        method: "GET", // HTTP method
        headers: {
          Authorization: `Bearer ${token}`, // Bearer token for authentication
        },
      }),
      providesTags: ["Portfolio"], // Cache the data with the "Portfolio" tag
    }),

    // Mutation to delete a portfolio link for a specific student
    deletePortfolioLink: builder.mutation({
      query: ({ portfolioId, token }) => ({
        url: `/portfolio/${portfolioId}`, // API endpoint for deleting a portfolio link
        method: "DELETE", // HTTP method
        headers: {
          Authorization: `Bearer ${token}`, // Bearer token for authentication
        },
      }),
      invalidatesTags: ["Portfolio"], // Invalidate cache after deletion
    }),
  }),
});

export const {
  useSavePortfolioLinkMutation,
  useGetPortfolioLinkQuery,
  useGetAllPortfolioQuery,
  useDeletePortfolioLinkMutation,
} = portfolioApi;
